import { TenantEntity } from '../TenantEntity'

export class Billing extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'Billing'
  }
  get bankAccount() {
    return this._data.bankAccount
  }
  set bankAccount(bankAccount) {
    this._data.bankAccount = bankAccount || ''
  }
  get swiftCode() {
    return this._data.swiftCode
  }
  set swiftCode(swiftCode) {
    this._data.swiftCode = swiftCode || ''
  }
  get clearingState() {
    return this._data.clearingState
  }
  set clearingState(clearingState) {
    this._data.clearingState = clearingState || 0
  }
  get agentRefNo() {
    return this._data.agentRefNo
  }
  set agentRefNo(agentRefNo) {
    this._data.agentRefNo = agentRefNo || ''
  }
  get billingId() {
    return this._data.billingId
  }
  set billingId(billingId) {
    this._data.billingId = billingId || 0
  }
  get billingNo() {
    return this._data.billingNo
  }
  set billingNo(billingNo) {
    this._data.billingNo = billingNo || ''
  }
  get counterPartyBillingNo() {
    return this._data.counterPartyBillingNo
  }
  set counterPartyBillingNo(counterPartyBillingNo) {
    this._data.counterPartyBillingNo = counterPartyBillingNo || ''
  }
  get billingType() {
    return this._data.billingType
  }
  set billingType(billingType) {
    this._data.billingType = billingType || ''
  }
  get ar() {
    return this._data.ar
  }
  set ar(ar) {
    this._data.ar = ar || false
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state || 0
  }
  get accountId() {
    return this._data.accountId
  }
  set accountId(accountId) {
    this._data.accountId = accountId || 0
  }
  get contact() {
    return this._data.contact
  }
  set contact(contact) {
    this._data.contact = contact || ''
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency || ''
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.rate = rate || 0.0
  }
  get chargeCurrency1() {
    return this._data.chargeCurrency1
  }
  set chargeCurrency1(chargeCurrency1) {
    this._data.chargeCurrency1 = chargeCurrency1 || ''
  }
  get chargeRate1() {
    return this._data.chargeRate1
  }
  set chargeRate1(chargeRate1) {
    this._data.chargeRate1 = chargeRate1 || 0.0
  }
  get chargeCurrency2() {
    return this._data.chargeCurrency2
  }
  set chargeCurrency2(chargeCurrency2) {
    this._data.chargeCurrency2 = chargeCurrency2 || ''
  }
  get chargeRate2() {
    return this._data.chargeRate2
  }
  set chargeRate2(chargeRate2) {
    this._data.chargeRate2 = chargeRate2 || 0.0
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0.0
  }
  get taxAmount() {
    return this._data.taxAmount
  }
  set taxAmount(taxAmount) {
    this._data.taxAmount = taxAmount || 0.0
  }
  get currencyAmount() {
    return this._data.currencyAmount
  }
  set currencyAmount(currencyAmount) {
    this._data.currencyAmount = currencyAmount || ''
  }
  get bankAccountId() {
    return this._data.bankAccountId
  }
  set bankAccountId(bankAccountId) {
    this._data.bankAccountId = bankAccountId || 0
  }
  get invoiceDemand() {
    return this._data.invoiceDemand
  }
  set invoiceDemand(invoiceDemand) {
    this._data.invoiceDemand = invoiceDemand || ''
  }
  get title() {
    return this._data.title
  }
  set title(title) {
    this._data.title = title || ''
  }
  get percentage() {
    return this._data.percentage
  }
  set percentage(percentage) {
    this._data.percentage = percentage || 0.0
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo || ''
  }
  get mbl() {
    return this._data.mbl
  }
  set mbl(mbl) {
    this._data.mbl = mbl || ''
  }
  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol || ''
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod || ''
  }
  get pod2() {
    return this._data.pod2
  }
  set pod2(pod2) {
    this._data.pod2 = pod2 || ''
  }
  get ETD() {
    return this._data.ETD
  }
  set ETD(ETD) {
    this._data.ETD = ETD
  }
  get ETA() {
    return this._data.ETA
  }
  set ETA(ETA) {
    this._data.ETA = ETA
  }
  get voyageFlight() {
    return this._data.voyageFlight
  }
  set voyageFlight(voyageFlight) {
    this._data.voyageFlight = voyageFlight || ''
  }
  get containerSeal() {
    return this._data.containerSeal
  }
  set containerSeal(containerSeal) {
    this._data.containerSeal = containerSeal || ''
  }
  get titleBranchId() {
    return this._data.titleBranchId
  }
  set titleBranchId(titleBranchId) {
    this._data.titleBranchId = titleBranchId || 0
  }
  get billingAddress() {
    return this._data.billingAddress
  }
  set billingAddress(billingAddress) {
    this._data.billingAddress = billingAddress || ''
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark || ''
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy || 0
  }
  get inputByDep() {
    return this._data.inputByDep
  }
  set inputByDep(inputByDep) {
    this._data.inputByDep = inputByDep || 0
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get printDate() {
    return this._data.printDate
  }
  set printDate(printDate) {
    this._data.printDate = printDate
  }
  get invalidBy() {
    return this._data.invalidBy
  }
  set invalidBy(invalidBy) {
    this._data.invalidBy = invalidBy || 0
  }
  get invalidDate() {
    return this._data.invalidDate
  }
  set invalidDate(invalidDate) {
    this._data.invalidDate = invalidDate
  }
  get cancellationDetails() {
    return this._data.cancellationDetails
  }
  set cancellationDetails(cancellationDetails) {
    this._data.cancellationDetails = cancellationDetails || ''
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get sales() {
    return this._data.sales
  }
  set sales(sales) {
    this._data.sales = sales || 0
  }
  get sourceCurrency1() {
    return this._data.sourceCurrency1
  }
  set sourceCurrency1(sourceCurrency1) {
    this._data.sourceCurrency1 = sourceCurrency1 || ''
  }
  get sourceCurrency2() {
    return this._data.sourceCurrency2
  }
  set sourceCurrency2(sourceCurrency2) {
    this._data.sourceCurrency2 = sourceCurrency2 || ''
  }
  get sourceCurrency3() {
    return this._data.sourceCurrency3
  }
  set sourceCurrency3(sourceCurrency3) {
    this._data.sourceCurrency3 = sourceCurrency3 || ''
  }
  get sourceRate1() {
    return this._data.sourceRate1
  }
  set sourceRate1(sourceRate1) {
    this._data.sourceRate1 = sourceRate1 || 0.0
  }
  get sourceRate2() {
    return this._data.sourceRate2
  }
  set sourceRate2(sourceRate2) {
    this._data.sourceRate2 = sourceRate2 || 0.0
  }
  get sourceRate3() {
    return this._data.sourceRate3
  }
  set sourceRate3(sourceRate3) {
    this._data.sourceRate3 = sourceRate3 || 0.0
  }
  get amount1() {
    return this._data.amount1
  }
  set amount1(amount1) {
    this._data.amount1 = amount1 || 0.0
  }
  get amount2() {
    return this._data.amount2
  }
  set amount2(amount2) {
    this._data.amount2 = amount2 || 0.0
  }
  get amount3() {
    return this._data.amount3
  }
  set amount3(amount3) {
    this._data.amount3 = amount3 || 0.0
  }
  get buyerTaxAccount() {
    return this._data.buyerTaxAccount
  }
  set buyerTaxAccount(buyerTaxAccount) {
    this._data.buyerTaxAccount = buyerTaxAccount || ''
  }
  get buyerBank() {
    return this._data.buyerBank
  }
  set buyerBank(buyerBank) {
    this._data.buyerBank = buyerBank || ''
  }
  get buyerBankAccount() {
    return this._data.buyerBankAccount
  }
  set buyerBankAccount(buyerBankAccount) {
    this._data.buyerBankAccount = buyerBankAccount || ''
  }
  get buyerAddress() {
    return this._data.buyerAddress
  }
  set buyerAddress(buyerAddress) {
    this._data.buyerAddress = buyerAddress || ''
  }
  get buyerTelephone() {
    return this._data.buyerTelephone
  }
  set buyerTelephone(buyerTelephone) {
    this._data.buyerTelephone = buyerTelephone || ''
  }
  get markUser() {
    return this._data.markUser
  }
  set markUser(markUser) {
    this._data.markUser = markUser || 0
  }
  get markDate() {
    return this._data.markDate
  }
  set markDate(markDate) {
    this._data.markDate = markDate
  }
  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    this._data.mark = mark || false
  }
  get settlementAgent() {
    return this._data.settlementAgent
  }
  set settlementAgent(settlementAgent) {
    this._data.settlementAgent = settlementAgent || ''
  }
  get settlementAgentId() {
    return this._data.settlementAgentId
  }
  set settlementAgentId(settlementAgentId) {
    this._data.settlementAgentId = settlementAgentId || 0
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get billingGroupUuid() {
    return this._data.billingGroupUuid
  }
  set billingGroupUuid(billingGroupUuid) {
    this._data.billingGroupUuid = billingGroupUuid
  }
  get confirmDate() {
    return this._data.confirmDate
  }
  set confirmDate(confirmDate) {
    this._data.confirmDate = confirmDate
  }
  get accountAddr() {
    return this._data.accountAddr
  }
  set accountAddr(accountAddr) {
    this._data.accountAddr = accountAddr
  }
  get accountContacts() {
    return this._data.accountContacts
  }
  set accountContacts(accountContacts) {
    this._data.accountContacts = accountContacts
  }
  get accountContactsTel() {
    return this._data.accountContactsTel
  }
  set accountContactsTel(accountContactsTel) {
    this._data.accountContactsTel = accountContactsTel
  }
  // 发票类型
  get invoiceType() {
    return this._data.invoiceType
  }
  set invoiceType(invoiceType) {
    this._data.invoiceType = invoiceType || ''
  }
  // 发票种类
  get invoiceMakeType() {
    return this._data.invoiceMakeType
  }
  set invoiceMakeType(invoiceMakeType) {
    this._data.invoiceMakeType = invoiceMakeType || ''
  }
  get confirmed() {
    return this._data.confirmed
  }
  set confirmed(confirmed) {
    this._data.confirmed = confirmed || false
  }
  get revoked() {
    return this._data.revoked
  }
  set revoked(revoked) {
    this._data.revoked = revoked || false
  }
  get prePayment() {
    return this._data.prePayment
  }
  set prePayment(prePayment) {
    this._data.prePayment = prePayment || false
  }
  get prePaymentBy() {
    return this._data.prePaymentBy
  }
  set prePaymentBy(prePaymentBy) {
    this._data.prePaymentBy = prePaymentBy || 0
  }
  get prePaymentDate() {
    return this._data.prePaymentDate
  }
  set prePaymentDate(prePaymentDate) {
    this._data.prePaymentDate = prePaymentDate || null
  }

  // 虚拟字段(非数据库实体字段)------------------
  get taxFreeAmount() {
    return this._data.taxFreeAmount
  }
  set taxFreeAmount(taxFreeAmount) {
    this._data.taxFreeAmount = taxFreeAmount || 0.0
  }
  // 删除掉的费用
  get removedCharges() {
    return this._data.removedCharges
  }
  set removedCharges(removedCharges) {
    this._data.removedCharges = removedCharges || []
  }
  // 更新的费用
  get updateCharges() {
    return this._data.updateCharges
  }
  set updateCharges(updateCharges) {
    this._data.updateCharges = updateCharges || []
  }
  // 新增的费用
  get createCharges() {
    return this._data.createCharges
  }
  set createCharges(createCharges) {
    this._data.createCharges = createCharges || []
  }
  // 当前分公司Id
  get currentOfficeId() {
    return this._data.currentOfficeId
  }
  set currentOfficeId(currentOfficeId) {
    this._data.currentOfficeId = currentOfficeId || 0
  }
  // 结算对象虚拟字段，结算代理改变时，结算对象也要发生变更
  get settlement() {
    return this._data.settlement
  }
  set settlement(settlement) {
    this._data.settlement = settlement || ''
  }
  // 创建账单时选择的收付方式 0：应付；1：应收；-1：全部（应收和应付费用一起创建账单） 默认选择应收
  get makeBillingPaymentReceiveMethod() {
    return this._data.makeBillingPaymentReceiveMethod
  }
  set makeBillingPaymentReceiveMethod(makeBillingPaymentReceiveMethod) {
    this._data.makeBillingPaymentReceiveMethod = makeBillingPaymentReceiveMethod || 1
  }
  get detailMakeInvoice() {
    return this._data.detailMakeInvoice
  }
  set detailMakeInvoice(detailMakeInvoice) {
    this._data.detailMakeInvoice = detailMakeInvoice
  }
  get splitMakeInvoice() {
    return this._data.splitMakeInvoice
  }
  set splitMakeInvoice(splitMakeInvoice) {
    this._data.splitMakeInvoice = splitMakeInvoice
  }
  get remarkAddContent() {
    return this._data.remarkAddContent
  }
  set remarkAddContent(remarkAddContent) {
    this._data.remarkAddContent = remarkAddContent
  }
  get invoiceUsdRemark() {
    return this._data.invoiceUsdRemark
  }
  set invoiceUsdRemark(invoiceUsdRemark) {
    this._data.invoiceUsdRemark = invoiceUsdRemark
  }
  get invoiceRemark() {
    return this._data.invoiceRemark
  }
  set invoiceRemark(invoiceRemark) {
    this._data.invoiceRemark = invoiceRemark
  }
  get splitBillNo() {
    return this._data.splitBillNo
  }
  set splitBillNo(splitBillNo) {
    this._data.splitBillNo = splitBillNo
  }
  get settlementType() {
    return this._data.settlementType
  }
  set settlementType(settlementType) {
    if (typeof settlementType === 'number') {
      this._data.settlementType = settlementType
    } else {
      this._data.settlementType = 1
    }
  }
  // 创建账单方式【0：结算对象 1、结算代理】
  get createBillWay() {
    return this._data.createBillWay
  }
  set createBillWay(createBillWay) {
    this._data.createBillWay = createBillWay || 0
  }
  get overseaInvoiceDate() {
    return this._data.overseaInvoiceDate
  }
  set overseaInvoiceDate(overseaInvoiceDate) {
    this._data.overseaInvoiceDate = overseaInvoiceDate
  }
  get customerEmail() {
    return this._data.customerEmail
  }
  set customerEmail(customerEmail) {
    this._data.customerEmail = customerEmail
  }
  get redPunchState() {
    return this._data.redPunchState
  }
  set redPunchState(redPunchState) {
    this._data.redPunchState = redPunchState
  }
  get redPunchDate() {
    return this._data.redPunchDate
  }
  set redPunchDate(redPunchDate) {
    this._data.redPunchDate = redPunchDate
  }
  get redPunchBy() {
    return this._data.redPunchBy
  }
  set redPunchBy(redPunchBy) {
    this._data.redPunchBy = redPunchBy
  }
}
